var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoasiento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.73 40.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.61,4.35v13.73c-1.95.83-3.32,2.77-3.32,5.03v9.38H8.44v-9.38c0-2.26-1.37-4.2-3.32-5.03V4.35C5.12,1.95,7.07,0,9.47,0h23.78c2.41,0,4.35,1.95,4.35,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.73,23.12v17.83H0v-17.83c0-1.64,1.33-2.97,2.97-2.97.82,0,1.56.33,2.1.87.02.01.03.03.04.05.51.53.83,1.26.83,2.05v11.88h30.83v-11.88c0-.79.31-1.52.83-2.05.54-.57,1.3-.92,2.15-.92s1.56.33,2.1.87c.54.53.87,1.28.87,2.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoasiento);
export default __webpack_public_path__ + "static/media/icono asiento.c2fe813a5db0e9b75d3245f86129093e.svg";
export { ForwardRef as ReactComponent };